export const APPID = {
  WETV: 'wetv',
  IFLIX: 'iflix',
};

export const KEY_NAME = {
  DOWN: 'down',
  UP: 'up',
  LEFT: 'left',
  RIGHT: 'right',
};

export const DEFN_LOCAL_KEY = 'definition';
